import React from "react";
import { useNavigate } from "react-router-dom";
import { Database } from "lucide-react";
import { getCurrentCustomer } from "../lib/customerSession";

/**
 * Light blue banner that prompts active customers to connect Tally when no
 * real data has landed for the current module. Hidden for visitors so they
 * just see the demo dashboard without any nag.
 */
export default function ConnectTallyBanner({ dataAvailable, isLoading }) {
  const navigate = useNavigate();
  const customer = (() => {
    try { return getCurrentCustomer(); } catch (_e) { return null; }
  })();
  // Hide while the initial dashboard-data fetch is in-flight; otherwise the
  // banner briefly flashes "Connect your Tally" before the real
  // dataAvailable=true arrives for customers who already synced. (Feb 2026)
  if (isLoading) return null;
  // Only show for active customers who don't yet have data.
  if (dataAvailable) return null;
  if (!customer || customer.status !== "active") return null;

  return (
    <div
      data-testid="connect-tally-banner"
      style={{
        background: "#EFF6FF",
        borderBottom: "1px solid #DBEAFE",
        padding: "10px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#374151", fontSize: 13 }}>
        <Database size={15} style={{ color: "#1D4ED8" }} />
        Connect your Tally to see live data for this module
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span style={{ color: "#9CA3AF", fontSize: 12 }}>
          Already connected? Data syncs every hour
        </span>
        <button
          data-testid="connect-tally-cta"
          onClick={() => navigate("/connect/tally")}
          style={{
            background: "white",
            color: "#1D4ED8",
            border: "1px solid #1D4ED8",
            borderRadius: 6,
            padding: "5px 12px",
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Connect Tally
        </button>
      </div>
    </div>
  );
}
